import { DateTime } from 'luxon';

export const convertUTCDateTimeToLocalLuxon = (dateTime: string): DateTime =>
    DateTime.fromISO(dateTime, { zone: 'utc' }).toLocal();

export const convertLocalLuxonToUTCDateTime = (
    localDateTime: DateTime
): string => localDateTime.toUTC().toISO()?.split('.')[0] ?? '';
